/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S7_TitleInputs */

const en_guide_json_syntax_errors_s7_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A quick checklist before you debug`)
};

const ko_guide_json_syntax_errors_s7_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디버깅 전 빠른 체크리스트`)
};

const ja_guide_json_syntax_errors_s7_title = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバッグ前のクイックチェックリスト`)
};

/**
* | output |
* | --- |
* | "A quick checklist before you debug" |
*
* @param {Guide_Json_Syntax_Errors_S7_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s7_title = /** @type {((inputs?: Guide_Json_Syntax_Errors_S7_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S7_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s7_title(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s7_title(inputs)
	return ja_guide_json_syntax_errors_s7_title(inputs)
});